import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Trash2, Loader2 } from "lucide-react";
import axios from "axios";
import { toast } from "sonner";
import { API } from "@/lib/api";
import { useAuth } from "@/lib/auth";
import { errorText } from "@/lib/family";

export const DeleteAccount = () => {
  const { setUser } = useAuth();
  const nav = useNavigate();
  const [open, setOpen] = useState(false);
  const [pin, setPin] = useState("");
  const [confirm, setConfirm] = useState("");
  const [busy, setBusy] = useState(false);
  const ready = pin.length >= 4 && confirm.trim().toUpperCase() === "DELETE";
  const go = async () => {
    setBusy(true);
    try {
      await axios.delete(`${API}/account`, { data: { pin, confirm } });
      localStorage.removeItem("pp_device_id");
      setUser(false);
      toast.success("Your NICE account has been permanently deleted.");
      nav("/login");
    } catch (e) { toast.error(errorText(e)); setBusy(false); }
  };
  if (!open) return (
    <button className="pp-ghost mt-6" onClick={() => setOpen(true)} data-testid="delete-account-open">
      <Trash2 className="h-4 w-4" /> Delete my NICE account
    </button>
  );
  return (
    <section className="pp-card max-w-lg mt-6 pp-danger-card" data-testid="delete-account-panel">
      <p className="pp-label">Parents only</p>
      <h2 className="pp-h2">Permanently delete your NICE account</h2>
      <p className="mt-2">This permanently deletes your NICE account and your family's NICE data: child profiles, chat history, practice, apologies, Golden Acorns and thank-you excerpts, parent awards, teacher notes and photos, rewards and progress, and your Siri family key. <b>This cannot be undone.</b></p>
      <p className="mt-2 text-sm opacity-80">If another parent or grandparent shares your family, the family's data stays for them and only your account is removed. A web membership is canceled automatically. If you subscribed through the App Store or Google Play, cancel it there too. Payment records we are required to keep are retained. You may want to download your data first.</p>
      <input className="pp-input mt-4" type="password" inputMode="numeric" placeholder="Parent PIN" value={pin}
        onChange={(e) => setPin(e.target.value.replace(/\D/g, "").slice(0, 8))} data-testid="delete-account-pin" />
      <input className="pp-input mt-3" placeholder='Type DELETE to confirm' value={confirm} onChange={(e) => setConfirm(e.target.value)} data-testid="delete-account-confirm" />
      <div className="pp-actions">
        <button className="pp-primary pp-danger" disabled={!ready || busy} onClick={go} data-testid="delete-account-submit">
          {busy ? <Loader2 className="h-5 w-5 animate-spin" /> : "Permanently delete my account"}
        </button>
        <button className="pp-ghost" onClick={() => { setOpen(false); setPin(""); setConfirm(""); }} data-testid="delete-account-cancel">Keep my account</button>
      </div>
    </section>
  );
};
